import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { setCrm } from "../../features/crm/crmSlice"

import {
    selectCurrentId,
    selectCurrentRole
} from "../../features/auth/authSlice"

import { useRefreshMutation } from "../../features/auth/authApiSlice"
import { useGetCrmIdByAdvisorIdMutation } from "../../features/crm/crmApiSlice"

import LandingPage from "./LandingPage"

const LandingRedirect = () => {
    const id = useSelector(selectCurrentId)
    const role = useSelector(selectCurrentRole)
    const dispatch = useDispatch()

    const [refresh, {
        isUninitialized,
        isLoading,
        isError
    }] = useRefreshMutation()

    const [getCrmIdByAdvisorId] =
        useGetCrmIdByAdvisorIdMutation()

    const [crmId, setCrmId] = useState(null)
    const [loadingCrm, setLoadingCrm] = useState(false)

    useEffect(() => {
        if (!id && isUninitialized) {
            refresh()
        }
    }, [id, isUninitialized])

    useEffect(() => {
        const retrieveCrm = async () => {
            if (role === "ADVISOR" && id) {
                try {
                    setLoadingCrm(true)

                    const crm =
                        await getCrmIdByAdvisorId(id).unwrap()

                    setCrmId(crm?.id)
                    dispatch(setCrm(crm?.id))

                } catch (err) {
                    console.log(err)
                } finally {
                    setLoadingCrm(false)
                }
            }
        }

        retrieveCrm()
    }, [id, role])

    if (isUninitialized || isLoading || loadingCrm) {
        return null
    }

    if (!id || !role || isError) {
        return <LandingPage />
    }

    if (role === "ADVISOR") {
        if (!crmId) {
            return null
        }

        return (
            <Navigate
                to={`/dash/crm/${crmId}`}
                replace
            />
        )
    }

    if (role === "SUPPORT_STAFF") {
        return <Navigate to="/dash/support" replace />
    }

    return <Navigate to="/dash" replace />
}

export default LandingRedirect